function ErrorPage() {
  return (
    <div>
      <p>Error! Page not found</p>
    </div>
  );
}

export default ErrorPage